import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=1a0cef6f&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=ts"
export * from "./confirmation.vue?vue&type=script&lang=ts"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=1a0cef6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0cef6f",
  null
  
)

export default component.exports